export default __webpack_public_path__ + "static/media/Kenna Security.67f4560a.png";